import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';

import { Observable, of, tap } from 'rxjs';

import { Plant } from '../models/plant';

import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class PlantService {
  private http = inject(HttpClient);
  configService = inject(ConfigService);

  allPlants = signal<Plant[]>([]);

  getPlants(): Observable<Plant[]> {
    if (this.allPlants().length === 0) {
      return this.http
        .get<Plant[]>(`${this.configService.getConfiguration().apiHost}/api/plants`)
        .pipe(tap((plants) => this.allPlants.set(plants)));
    }
    return of(this.allPlants());
  }
}
